const Footer = () => {
	return (
		<footer
			style={{
				padding: '1rem',
				background: '#eee',
				textAlign: 'center',
				fontSize: '0.85rem'
			}}
		>
			<p>&copy; {new Date().getFullYear()} Quantum Cat</p>
		</footer>

	)
}

export default Footer
